"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9363],{

/***/ 25409:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BD": function() { return /* binding */ fetchMyLiveSession; },
/* harmony export */   "CA": function() { return /* binding */ stopLiveSharedEpisode; },
/* harmony export */   "Do": function() { return /* binding */ fetchLiveDiscovery; },
/* harmony export */   "EW": function() { return /* binding */ fetchLiveViewers; },
/* harmony export */   "F7": function() { return /* binding */ sendLiveMessage; },
/* harmony export */   "GB": function() { return /* binding */ createLiveMediaCredential; },
/* harmony export */   "HN": function() { return /* binding */ updateLiveSharedEpisodePresentation; },
/* harmony export */   "JQ": function() { return /* binding */ activateLiveSharedEpisode; },
/* harmony export */   "LT": function() { return /* binding */ fetchLiveEvents; },
/* harmony export */   "Ny": function() { return /* binding */ deleteLiveViewerRestriction; },
/* harmony export */   "Op": function() { return /* binding */ closeLiveSession; },
/* harmony export */   "T5": function() { return /* binding */ heartbeatLiveSession; },
/* harmony export */   "i0": function() { return /* binding */ fetchLiveSharedEpisodeContent; },
/* harmony export */   "kJ": function() { return /* binding */ sendLiveDonation; },
/* harmony export */   "kk": function() { return /* binding */ fetchUserLiveSessions; },
/* harmony export */   "n5": function() { return /* binding */ fetchLiveSession; },
/* harmony export */   "n8": function() { return /* binding */ createLiveViewerModeration; },
/* harmony export */   "ti": function() { return /* binding */ openLiveSession; },
/* harmony export */   "uJ": function() { return /* binding */ createLiveWebSocketTicket; },
/* harmony export */   "w$": function() { return /* binding */ uploadLiveMessageImage; },
/* harmony export */   "xV": function() { return /* binding */ getLiveWebSocketUrl; },
/* harmony export */   "yr": function() { return /* binding */ fetchLiveViewerRestrictions; }
/* harmony export */ });
/* unused harmony exports unwrapLiveMessageImageUploadGrant, createLiveMessageImageUpload */
/* harmony import */ var _utils_imageUpload__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93705);
/* harmony import */ var _utils_misc__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45874);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39322);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};



var unwrapLiveMessageImageUploadGrant = function(data) {
    if (!data || typeof data !== "object" || !("result" in data)) {
        return data;
    }
    return data.result;
};
var fetchUserLiveSessions = function() {
    var _ref = _asyncToGenerator(function(userId) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_2__/* .api.get */ .hi.get("/users/".concat(userId, "/lives/"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchUserLiveSessions(userId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchMyLiveSession = function() {
    var _ref = _asyncToGenerator(function() {
        var data, ref;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_2__/* .api.get */ .hi.get("/users/me/lives/")
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        (ref = data[0]) !== null && ref !== void 0 ? ref : null
                    ];
            }
        });
    });
    return function fetchMyLiveSession() {
        return _ref.apply(this, arguments);
    };
}();
function validateLivePaginationUrl(next) {
    if (false) {}
    var localOrigin =  false ? 0 : window.location.origin;
    var apiBase = new URL("https://api.chatie.me", localOrigin);
    var nextUrl = new URL(next, apiBase);
    if (nextUrl.origin !== apiBase.origin) {
        throw new Error("허용되지 않은 라이브 목록 페이지 URL입니다.");
    }
}
var fetchLiveDiscovery = function() {
    var _ref = _asyncToGenerator(function(next) {
        var url, data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = next !== null && next !== void 0 ? next : "/lives/";
                    if (next) {
                        validateLivePaginationUrl(next);
                    }
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_2__/* .api.get */ .hi.get(url)
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchLiveDiscovery(next) {
        return _ref.apply(this, arguments);
    };
}();
var openLiveSession = function() {
    var _ref = _asyncToGenerator(function(payload) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_2__/* .api.post */ .hi.post("/lives/", payload)
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function openLiveSession(payload) {
        return _ref.apply(this, arguments);
    };
}();
var fetchLiveSession = function() {
    var _ref = _asyncToGenerator(function(liveId) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_2__/* .api.get */ .hi.get("/lives/".concat(liveId, "/"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchLiveSession(liveId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchLiveSharedEpisodeContent = function() {
    var _ref = _asyncToGenerator(function(liveId, snapshotId) {
        var query, data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    query = (0,_utils_misc__WEBPACK_IMPORTED_MODULE_1__/* .toQueryString */ .UK)({
                        snapshotId: snapshotId
                    });
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_2__/* .api.get */ .hi.get("/lives/".concat(liveId, "/shared-episode/content/").concat(query), {
                            responseType: "json",
                            transformResponse: ___WEBPACK_IMPORTED_MODULE_2__/* .defaultTransformResponse */ .aH
                        })
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchLiveSharedEpisodeContent(liveId, snapshotId) {
        return _ref.apply(this, arguments);
    };
}();
var activateLiveSharedEpisode = function() {
    var _ref = _asyncToGenerator(function(liveId, payload) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_2__/* .api.put */ .hi.put("/lives/".concat(liveId, "/shared-episode/"), payload)
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function activateLiveSharedEpisode(liveId, payload) {
        return _ref.apply(this, arguments);
    };
}();
var updateLiveSharedEpisodePresentation = function() {
    var _ref = _asyncToGenerator(function(liveId, payload) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_2__/* .api.patch */ .hi.patch("/lives/".concat(liveId, "/shared-episode/"), payload)
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function updateLiveSharedEpisodePresentation(liveId, payload) {
        return _ref.apply(this, arguments);
    };
}();
var stopLiveSharedEpisode = function() {
    var _ref = _asyncToGenerator(function(liveId, payload) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_2__/* .api.post */ .hi.post("/lives/".concat(liveId, "/shared-episode-closures/"), payload)
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function stopLiveSharedEpisode(liveId, payload) {
        return _ref.apply(this, arguments);
    };
}();
var closeLiveSession = function() {
    var _ref = _asyncToGenerator(function(liveId) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_2__/* .api.post */ .hi.post("/lives/".concat(liveId, "/closure/"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function closeLiveSession(liveId) {
        return _ref.apply(this, arguments);
    };
}();
var heartbeatLiveSession = function() {
    var _ref = _asyncToGenerator(function(liveId) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_2__/* .api.post */ .hi.post("/lives/".concat(liveId, "/heartbeats/"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function heartbeatLiveSession(liveId) {
        return _ref.apply(this, arguments);
    };
}();
var createLiveWebSocketTicket = function() {
    var _ref = _asyncToGenerator(function(liveId) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_2__/* .api.post */ .hi.post("/lives/".concat(liveId, "/websocket-tickets/"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function createLiveWebSocketTicket(liveId) {
        return _ref.apply(this, arguments);
    };
}();
var createLiveMediaCredential = function() {
    var _ref = _asyncToGenerator(function(liveId, publisherCapability) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_2__/* .api.post */ .hi.post("/lives/".concat(liveId, "/media-credentials/"), publisherCapability)
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function createLiveMediaCredential(liveId, publisherCapability) {
        return _ref.apply(this, arguments);
    };
}();
var fetchLiveEvents = function() {
    var _ref = _asyncToGenerator(function(liveId, afterSequence) {
        var limit, query, data;
        var _arguments = arguments;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    limit = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 100;
                    query = (0,_utils_misc__WEBPACK_IMPORTED_MODULE_1__/* .toQueryString */ .UK)({
                        afterSequence: afterSequence,
                        limit: limit
                    });
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_2__/* .api.get */ .hi.get("/lives/".concat(liveId, "/events/").concat(query))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchLiveEvents(liveId, afterSequence) {
        return _ref.apply(this, arguments);
    };
}();
var sendLiveMessage = function() {
    var _ref = _asyncToGenerator(function(liveId, payload) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_2__/* .api.post */ .hi.post("/lives/".concat(liveId, "/messages/"), payload)
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function sendLiveMessage(liveId, payload) {
        return _ref.apply(this, arguments);
    };
}();
var createLiveMessageImageUpload = function() {
    var _ref = _asyncToGenerator(function(liveId, filename) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_2__/* .api.post */ .hi.post("/lives/".concat(liveId, "/message-image-uploads/"), {
                            filename: filename
                        }, {
                            // Presigned form field names such as `x-amz-signature` are opaque.
                            // The default API response transform camelizes nested object keys, so
                            // unwrap this response without transforming grant.params.
                            transformResponse: _toConsumableArray(___WEBPACK_IMPORTED_MODULE_2__/* .defaultTransformResponse */ .aH).concat([
                                unwrapLiveMessageImageUploadGrant
                            ])
                        })
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function createLiveMessageImageUpload(liveId, filename) {
        return _ref.apply(this, arguments);
    };
}();
var uploadLiveMessageImage = function() {
    var _ref = _asyncToGenerator(function(liveId, file) {
        var normalizedFile, grant, form, response;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,_utils_imageUpload__WEBPACK_IMPORTED_MODULE_0__/* .normalizeImageForUpload */ .f$)(file)
                    ];
                case 1:
                    normalizedFile = _state.sent();
                    return [
                        4,
                        createLiveMessageImageUpload(liveId, normalizedFile.name)
                    ];
                case 2:
                    grant = _state.sent();
                    form = new FormData();
                    Object.entries(grant.params).forEach(function(param) {
                        var _param = _slicedToArray(param, 2), name = _param[0], value = _param[1];
                        form.append(name, value);
                    });
                    form.append("file", normalizedFile, normalizedFile.name);
                    return [
                        4,
                        fetch(grant.url, {
                            method: "POST",
                            body: form,
                            credentials: "omit"
                        })
                    ];
                case 3:
                    response = _state.sent();
                    if (!response.ok) {
                        throw new Error("라이브 이미지 업로드에 실패했습니다: ".concat(response.status));
                    }
                    return [
                        2,
                        grant
                    ];
            }
        });
    });
    return function uploadLiveMessageImage(liveId, file) {
        return _ref.apply(this, arguments);
    };
}();
var fetchLiveViewers = function() {
    var _ref = _asyncToGenerator(function(liveId, next) {
        var url, data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = next !== null && next !== void 0 ? next : "/lives/".concat(liveId, "/viewers/");
                    if (next) {
                        validateLivePaginationUrl(next);
                    }
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_2__/* .api.get */ .hi.get(url)
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchLiveViewers(liveId, next) {
        return _ref.apply(this, arguments);
    };
}();
var createLiveViewerModeration = function() {
    var _ref = _asyncToGenerator(function(liveId, payload) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_2__/* .api.post */ .hi.post("/lives/".concat(liveId, "/viewer-moderations/"), payload)
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function createLiveViewerModeration(liveId, payload) {
        return _ref.apply(this, arguments);
    };
}();
var fetchLiveViewerRestrictions = function() {
    var _ref = _asyncToGenerator(function(next) {
        var url, data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = next !== null && next !== void 0 ? next : "/live-viewer-restrictions/";
                    if (next) {
                        validateLivePaginationUrl(next);
                    }
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_2__/* .api.get */ .hi.get(url)
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchLiveViewerRestrictions(next) {
        return _ref.apply(this, arguments);
    };
}();
var deleteLiveViewerRestriction = function() {
    var _ref = _asyncToGenerator(function(restrictionId) {
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_2__/* .api["delete"] */ .hi["delete"]("/live-viewer-restrictions/".concat(restrictionId, "/"))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function deleteLiveViewerRestriction(restrictionId) {
        return _ref.apply(this, arguments);
    };
}();
var sendLiveDonation = function() {
    var _ref = _asyncToGenerator(function(liveId, payload) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_2__/* .api.post */ .hi.post("/lives/".concat(liveId, "/donations/"), payload)
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function sendLiveDonation(liveId, payload) {
        return _ref.apply(this, arguments);
    };
}();
var getLiveWebSocketUrl = function(liveId, ticket) {
    var apiUrl = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "https://api.chatie.me";
    if (!apiUrl) {
        throw new Error("라이브 WebSocket URL을 만들 수 없습니다.");
    }
    var localOrigin =  false ? 0 : window.location.origin;
    var url = new URL(apiUrl, localOrigin);
    url.protocol = url.protocol === "https:" ? "wss:" : "ws:";
    url.pathname = "/ws/lives/".concat(liveId, "/");
    url.search = "";
    url.hash = "";
    url.searchParams.set("ticket", ticket);
    url.searchParams.set("viewer_count", "v1");
    url.searchParams.set("moderation", "v1");
    url.searchParams.set("shared_episode", "v1");
    return url.toString();
};


/***/ }),

/***/ 23521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GX": function() { return /* binding */ LIVE_MEDIA_PIPELINE_VERSION; },
/* harmony export */   "cC": function() { return /* binding */ isMediaLiveKind; },
/* harmony export */   "cp": function() { return /* binding */ isLiveMediaMode; }
/* harmony export */ });
var LIVE_MEDIA_PIPELINE_VERSION = 1;
var isLiveMediaMode = function(value) {
    return value === "original" || value === "character";
};
var isMediaLiveKind = function(value) {
    return value === "audio" || value === "video";
};


/***/ }),

/***/ 92126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JG": function() { return /* binding */ getLiveMediaDeviceErrorMessage; },
/* harmony export */   "cC": function() { return /* binding */ isMediaLiveKind; },
/* harmony export */   "fq": function() { return /* binding */ prepareLiveMediaStream; },
/* harmony export */   "tC": function() { return /* binding */ getLiveKindLabel; },
/* harmony export */   "u$": function() { return /* binding */ stopLiveMediaStream; }
/* harmony export */ });
/* unused harmony export getLiveMediaConstraints */
/* harmony import */ var _base_lib_live_media_domain__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23521);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};

var isMediaLiveKind = function(kind) {
    return (0,_base_lib_live_media_domain__WEBPACK_IMPORTED_MODULE_0__/* .isMediaLiveKind */ .cC)(kind);
};
var getLiveKindLabel = function(kind) {
    switch(kind){
        case "audio":
            return "음성";
        case "video":
            return "영상";
        default:
            return "채팅";
    }
};
var getLiveMediaConstraints = function(kind) {
    var mode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "original";
    return {
        audio: {
            echoCancellation: true,
            noiseSuppression: true,
            autoGainControl: true
        },
        video: kind === "video" ? {
            width: {
                ideal: mode === "character" ? 640 : 1280
            },
            height: {
                ideal: mode === "character" ? 480 : 720
            },
            frameRate: mode === "character" ? {
                ideal: 15,
                max: 15
            } : {
                ideal: 24,
                max: 30
            },
            facingMode: "user"
        } : false
    };
};
var prepareLiveMediaStream = function() {
    var _ref = _asyncToGenerator(function(kind) {
        var mode, ref;
        var _arguments = arguments;
        return __generator(this, function(_state) {
            mode = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "original";
            if (!((ref = navigator.mediaDevices) === null || ref === void 0 ? void 0 : ref.getUserMedia)) {
                throw new DOMException("이 환경에서는 카메라와 마이크를 사용할 수 없습니다.", "NotSupportedError");
            }
            return [
                2,
                navigator.mediaDevices.getUserMedia(getLiveMediaConstraints(kind, mode))
            ];
        });
    });
    return function prepareLiveMediaStream(kind) {
        return _ref.apply(this, arguments);
    };
}();
var stopLiveMediaStream = function(stream) {
    stream === null || stream === void 0 ? void 0 : stream.getTracks().forEach(function(track) {
        return track.stop();
    });
};
var getLiveMediaDeviceErrorMessage = function(error) {
    var target = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "media";
    var name = _instanceof(error, DOMException) ? error.name : "";
    var deviceLabel = target === "microphone" ? "마이크" : "카메라와 마이크";
    switch(name){
        case "NotAllowedError":
        case "SecurityError":
            return "".concat(deviceLabel, " 권한을 허용해주세요.");
        case "NotFoundError":
        case "DevicesNotFoundError":
            return target === "microphone" ? "사용할 수 있는 마이크를 찾지 못했어요." : "사용할 수 있는 카메라 또는 마이크를 찾지 못했어요.";
        case "NotReadableError":
        case "TrackStartError":
            return "다른 앱에서 ".concat(deviceLabel, "를 사용 중인지 확인해주세요.");
        case "NotSupportedError":
            return target === "microphone" ? "현재 환경에서는 음성 미리듣기를 사용할 수 없어요." : "현재 환경에서는 음성\xb7영상 라이브를 사용할 수 없어요.";
        default:
            return target === "microphone" ? "음성 미리듣기를 시작하지 못했어요. 다시 시도해주세요." : "카메라와 마이크를 준비하지 못했어요. 다시 시도해주세요.";
    }
};


/***/ })

}]);